export interface DivisionLike {
  name?: string | null;
  makerDivisionName?: string | null;
  organizationName?: string | null;
  uuid?: string | null;
}

export const getDivisionPrimaryLabel = (division: DivisionLike): string => {
  const candidates = [division.name, division.makerDivisionName, division.organizationName].filter(
    (value): value is string => typeof value === 'string' && value.trim().length > 0,
  );

  if (candidates.length > 0) {
    return candidates[0].trim();
  }

  return 'Division';
};

export const getDivisionSecondaryLabel = (division: DivisionLike & { id?: string | number }): string => {
  const uuid = division.uuid?.trim() || '';
  const id =
    typeof division.id === 'string' ? division.id : typeof division.id === 'number' ? division.id.toString() : null;

  const parts = [];
  if (uuid) parts.push(`UUID: ${uuid}`);
  if (id) parts.push(`ID: ${id}`);

  return parts.join(' ');
};

export const getDivisionTertiaryLabel = (division: DivisionLike & { srmEmailAddress?: string | null }): string => {
  const srmEmail = division.srmEmailAddress?.trim() || '';
  return srmEmail;
};

export const formatDivisionReplacement = (division: DivisionLike): string => {
  const primary = getDivisionPrimaryLabel(division);
  const uuid = division.uuid?.trim() || '';

  if (!uuid) {
    return primary;
  }

  return `${primary} (uuid=${uuid})`;
};
